export const PATHWAY_META = {
  "FREE IT": { tag: "FREE", tone: "green" },
  "SECONDHAND IT": { tag: "SECONDHAND", tone: "cream" },
  "RENT IT": { tag: "RENT", tone: "gold" },
  "USED IT": { tag: "USED", tone: "cream" },
  "BARTER IT": { tag: "BARTER", tone: "gold" },
  "RESCUE IT": { tag: "RESCUE", tone: "green" },
  "REFURBISH IT": { tag: "REFURB", tone: "cream" },
  "OPEN BOX IT": { tag: "OPEN BOX", tone: "cream" },
  "BORROW IT": { tag: "BORROW", tone: "green" },
  "DIRECT IT": { tag: "DIRECT", tone: "cream" },
  "CHEAPER IT": { tag: "CHEAPER", tone: "gold" },
  "DEAL IT": { tag: "DEAL", tone: "red" },
  "COUPON IT": { tag: "COUPON", tone: "red" },
  "CASHBACK IT": { tag: "CASHBACK", tone: "green" },
  "BENEFIT IT": { tag: "BENEFIT", tone: "gold" },
  "CLAIM IT": { tag: "CLAIM", tone: "gold" },
  "DIY IT": { tag: "DIY", tone: "cream" },
  "HIRE IT": { tag: "HIRE", tone: "cream" },
  "STUDENT SERVICE IT": { tag: "STUDENT", tone: "gold" },
  "SHARE IT": { tag: "SHARE", tone: "cream" },
  "SPREAD IT": { tag: "SPREAD", tone: "red" },
  "WAIT IT": { tag: "WAIT", tone: "gold" },
  "EXPERIENCE IT": { tag: "EXPERIENCE", tone: "green" },
  "SKIP IT": { tag: "SKIP", tone: "red" },
  "KEEP IT": { tag: "KEEP", tone: "green" },
};

export const TONES = { green: "#5FB878", gold: "#D4AF37", red: "#EF3340", cream: "#F4EEE5" };

export const HOME_EXAMPLES = [
  "a haircut", "groceries", "a couch", "car repair", "a flight", "a hotel",
  "a laptop", "a wedding dress", "dinner tonight", "a phone", "Canva", "a gym membership",
];

export function money(n) {
  if (n == null || isNaN(n)) return "—";
  return "$" + Number(n).toLocaleString(undefined, { maximumFractionDigits: 0 });
}
